import React from 'react';


export default function FieldRatingViewInImport(props) {

    let res = [];

    for (let i=1; i<=props.value; i++) {
        res.push(
            <div key={i} className={"ui5-ico-12 i5-star"} />
        )
    }


    return (
        <div className="div">
            {res}
        </div>
    );
}